module.exports = __webpack_public_path__ + "img/team-2.21d45a3b.jpg";